export default "/static/webpack/media/back-arrow.425fbbb9.svg";